module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['flexRow', 'blockRow', _vm.color, _vm.size, _vm.orientation],
    on: {
      "mouseenter": function($event) {
        _vm.showCount = true
      },
      "mouseleave": function($event) {
        _vm.showCount = false
      }
    }
  }, [(_vm.label.length > 0) ? _c('div', {
    staticClass: "rowLabel"
  }, [_vm._v("\n    " + _vm._s(_vm.showCount ? _vm.completed : _vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.numFit), function(n) {
    return _c('div', {
      class: 'block ' + (n == _vm.numFit ? 'last' : '')
    })
  }), _vm._v(" "), (_vm.numExtra > 0) ? _c('div', {
    staticClass: "additionalBlocksLabel"
  }, [_vm._v("+" + _vm._s(_vm.numExtra))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.numRemaining), function(n) {
    return _c('div', {
      staticClass: "block new quota"
    })
  }), _vm._v(" "), (_vm.quota == 0 && _vm.completed == 0) ? _c('div', {
    staticClass: "block new quota quotaMet"
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36db401b!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/StaticBlockRow.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-36db401b!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/StaticBlockRow.vue
// module chunks = 0